export const PaymentTranStsJSONSchema = {
  type: 'object',
  properties: {
    paymentTransactionStatus: {
      type: 'string',
      description: 'OD',
    },
    paymentTransactionAmount: {
      type: 'string',
    },
    transactionDate: {
      type: 'string',
    },
    paymentMethodCode: {
      type: 'string',
      description: 'OD',
    },
    cardType: {
      type: 'string',
    },
    lastFourDigitCard: {
      type: 'string',
    },
  },
}

export const PaymentTranStsJSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/paymentTransactionStatus',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Transaction Status',
        },
        {
          type: 'Control',
          scope: '#/properties/paymentTransactionAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Transaction Amount',
        },
        {
          type: 'Control',
          scope: '#/properties/transactionDate',
          component: 'ReadOnlyFieldWithJson',
          label: 'Transaction Date ',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/paymentMethodCode',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Method Code',
        },
        {
          type: 'Control',
          scope: '#/properties/cardType',
          component: 'ReadOnlyFieldWithJson',
          label: 'Card Type',
        },
        {
          type: 'Control',
          scope: '#/properties/lastFourDigitCard',
          component: 'ReadOnlyFieldWithJson',
          label: 'Last Four Digit (Card Number)',
        },
      ],
    },
  ],
}
